export default class Navigation {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Navigation;

		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-open-popup-sub-nav', function(e){
			e.preventDefault();
			var $this = $(this),
				$subMenu = $this.next('.popup-nav-sub');

			self.openPopupSubMenu($subMenu);
		});

		$(document).on('click', '.js-close-sub-menu', function(e){
			e.preventDefault();
			var $this = $(this),
				$subMenu = $this.closest('.popup-nav-sub');

			self.closePopupSubMenu($subMenu);
		});

		$(document).on('click', '.popup-nav-sub .mfp-close', function(e){
			e.preventDefault();
			var $this = $(this),
				$subMenu = $this.parents('.popup-nav-sub');

			self.closePopupSubMenu($subMenu);
		});

		$(document).on('popupOpen', function(e, src) {
	    	if (src == '#popup-navigation' || src == '#popup-navigation-account') {
	    		self.animateNavigation(src);
	    	}
	    });
	}

	openPopupSubMenu($subMenu) {
		let $popup = $subMenu.parents('.popup');

		$subMenu.show();

		$subMenu.animate({
			'left': '0%',
			'right': '0%'
		});

		$popup.scrollTop(0);

		$popup.addClass('mod-disable-scrolling');

		setTimeout(function() {
			$subMenu.parents('.popup-nav-sub').addClass('has-sub-nav-open');
		}, 400);
	}

	closePopupSubMenu($subMenu) {
		$subMenu.animate({
			'left': '100%',
			'right': '-100%'
		}, 400, function() {
			$subMenu.hide();
		});

		$subMenu.parents('.popup').removeClass('mod-disable-scrolling');

		$('.popup-nav-sub').removeClass('has-sub-nav-open');
	}

	animateNavigation(src) {
		const self = this;

		let $listItems = $(src + ' .anim-fade-right');

		$listItems.css({
			'transform': 'translateX(-50px)',
			'opacity': 0
		});

		setTimeout(function() {
			let offset = 0;
			$listItems.each(function() {
				let $item = $(this);
				offset += 100;

				setTimeout(function() {
					$item.addClass('is-animated');

					setTimeout(function() {
						$item.addClass('is-completed');
					}, 250);
				}, offset);
			});
		}, 200);
	}
}
